<template>
  <div class="content">
    <div class="md-layout">
      <!-- Configuration Table -->
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-70">
        <md-card>
          <md-card-header data-background-color="purple" class="md-layout">
            <div class="md-layout-item md-size-70">
              <h4 class="title">Server Configuration</h4>
              <p class="category">
                {{ configurationSearchedData.length }} Rows
                <span v-if="hasPendingChanges" style="margin-left:6px;color:#ff5252;">
                  - Pending changes
                </span>
              </p>
            </div>
            <div class="md-layout-item md-size-30 action-buttons">
              <md-button @click="getConfigurationData" class="md-icon-button md-dense refresh-btn">
                <md-tooltip md-direction="top">Refresh</md-tooltip>
                <md-icon>refresh</md-icon>
              </md-button>
              <search-box v-model="searchFilter" @doSearch="doSearch"></search-box>
              <md-button @click="showAddEditDialog = true" class="md-icon-button md-dense refresh-btn">
                <md-tooltip md-direction="top">Add</md-tooltip>
                <md-icon>add</md-icon>
              </md-button>
              <md-button  v-if="hasPendingChanges" @click="applyConfiguration" class="md-icon-button md-dense refresh-btn">
                <md-tooltip md-direction="top">Apply</md-tooltip>
                <md-icon>save</md-icon>
              </md-button>
            </div>
          </md-card-header>
          <md-card-content>
            <md-table
                v-model="configurationSearchedData"
                :md-sort.sync="currentSort"
                :md-sort-order.sync="currentSortOrder"
                md-sort-fn="customSort"
                table-header-color="purple"
                md-card
            >
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Key">
                  <span>
                    <md-tooltip md-direction="right" md-delay="500" class="helper-tooltip">
                      <span v-if="configurationHelper[item.key] && typeof configurationHelper[item.key] === 'object'">
                        {{ configurationHelper[item.key]["helper"] }}
                      </span>
                      <span v-else>
                        {{ configurationHelper[item.key] }}
                      </span>
                    </md-tooltip>
                    {{ item.key }}
                  </span>
                </md-table-cell>
                <md-table-cell md-label="Value">
                  <span
                      v-if="
                      !configurationHelper[item.key] ||
                      typeof configurationHelper[item.key] === 'string' ||
                      configurationHelper[item.key]['type'] !== 'password'
                    "
                  >
                    {{ item.value }}
                  </span>
                  <span v-else>****************</span>
                </md-table-cell>
                <md-table-cell class="configuration-table-actions">
                  <md-button @click="showEditConfigurationDialog(item.key, item.value)" class="md-icon-button md-dense">
                    <md-icon>edit</md-icon>
                  </md-button>
                  <md-button @click="deleteConfiguration(item.key)" class="md-icon-button md-dense">
                    <md-icon>delete</md-icon>
                  </md-button>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>

      <!-- Dialogues      -->
      <delete-dialog
          :show="showDeleteDialog"
          delete-api-name="deleteServerConfiguration"
          title="Delete Configuration Item"
          message="This action deletes this configuration permanently, Are you sure?"
          :request-body="{ key: deleteDialogKey }"
          @close="
          showDeleteDialog = false;
          deleteDialogKey = null;
        "
          @deleted="
          showDeleteDialog = false;
          deleteDialogKey = null;
          getConfigurationData();
        "
      ></delete-dialog>
      <waiting-for-server
          :show="showWaitingForServerDialog"
          @close="
          showWaitingForServerDialog = false;
          getConfigurationData();
        "
      ></waiting-for-server>
      <add-edit-configuration-item
          :show="showAddEditDialog"
          @close="closeAddEditDialog()"
          @saved="
            closeAddEditDialog();
            getConfigurationData();
          "
          :helper="configurationHelper"
          :_key="addEditKey"
          :value="addEditValue"
          :isEditMode="addEditDialogIsEditMode"
      ></add-edit-configuration-item>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-30">
        <md-card class="md-card-profile">
          <div class="md-card-avatar" data-background-color="orange">
            <md-icon>gavel</md-icon>
          </div>
          <md-card-content>
            <h4 class="card-title">License</h4>
            <h6 v-if="serverDetails && serverDetails.version" class="description">{{ serverDetails.version }}</h6>
            <br/>

            <md-table class="license-table">
              <md-table-row>
                <md-table-cell>Users Limit</md-table-cell>
                <md-table-cell v-if="license && license.usersLimit">{{ license.usersLimit }}</md-table-cell>
                <md-table-cell v-else>∞</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell>Applications Limit</md-table-cell>
                <md-table-cell v-if="license && license.applicationsLimit">
                  {{ license.applicationsLimit }}
                </md-table-cell>
                <md-table-cell v-else>∞</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell>Expires</md-table-cell>
                <md-table-cell v-if="license && license.expireDate">
                  {{ convertTimeToRelative(license.expireDate) }}
                </md-table-cell>
                <md-table-cell v-else>∞</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell>Verified</md-table-cell>
                <md-table-cell
                    v-if="license && license.settingsHash && license.settingsHash === serverDetails.settingsHash"
                >
                  <md-tooltip>Verified</md-tooltip>
                  <md-icon>verified</md-icon>
                </md-table-cell>
                <md-table-cell v-else>----</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell>Hash</md-table-cell>
                <md-table-cell v-if="serverDetails && serverDetails.settingsHash">
                  <div class="hash-container">
                    <span class="ellipsis-hash">
                      {{ serverDetails.settingsHash }}
                    </span>                    
                    <md-button
                        id="skey_button"
                        class="md-icon-button md-list-action"
                        @click="copyHash(serverDetails.settingsHash)"
                      >
                      <md-icon>file_copy</md-icon>
                    </md-button>

                  </div>
                </md-table-cell>
                <md-table-cell v-else>----</md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBox from "@/components/SearchBox";
import DeleteDialog from "../../components/DeleteDialog";
import WaitingForServer from "@/components/WaitingForServer";
import AddEditConfigurationItem from "@/pages/ServerConfiguration/AddEditConfigurationItem";
import * as moment from "moment";
import snakeCaseObjectKeysToCamelCase from "../../utils/snakeCaseObjectKeysToCamelCase";
import NotificationStore from "@/components/NotificationPlugin/NotificationStore";

export default {
  components: {
    SearchBox,
    DeleteDialog,
    WaitingForServer,
    AddEditConfigurationItem
  },
  data() {
    return {
      configurationData: {},
      configurationSearchedData: {},
      configurationHelper: {},
      searchFilter: "",
      dialogShownStatus: false,
      license: {
        usersLimit: null,
        applicationsLimit: null,
        expireDate: null,
        settingsHash: null
      },
      serverDetails: {
        version: null,
        settingsHash: null
      },
      showDeleteDialog: false,
      deleteDialogKey: null,
      showWaitingForServerDialog: false,
      showAddEditDialog: false,
      addEditDialogIsEditMode: false,
      addEditKey: null,
      addEditValue: null,
      hasPendingChanges: false
    };
  },
  methods: {
    async getConfigurationData() {
      const response = await this.$api.getServerConfiguration();
      this.configurationData = response.parsedData.settings.data;
      this.configurationHelper = response.parsedData.settings.helpers;

      const stateResponse = await this.$api.getServerConfigurationState();
      this.hasPendingChanges = stateResponse.parsedData.pending_changes === true;

      this.license = snakeCaseObjectKeysToCamelCase(response.parsedData.license);
      this.serverDetails = snakeCaseObjectKeysToCamelCase(response.parsedData.server);
      this.doSearch();
    },
    deleteConfiguration(key) {
      this.showDeleteDialog = true;
      this.deleteDialogKey = key;
    },
    doSearch() {
      const searchFilter = this.searchFilter;
      if (searchFilter.trim() !== "")
        this.configurationSearchedData = this.configurationData.filter(function (item) {
          return (
              item.key.toLowerCase().search(searchFilter.toLowerCase()) !== -1 ||
              item.value.toLowerCase().search(searchFilter.toLowerCase()) !== -1
          );
        });
      else this.configurationSearchedData = this.configurationData;
    },
    convertTimeToRelative(time) {
      return moment(time).fromNow();
    },
    showEditConfigurationDialog(key, value) {
      this.addEditKey = key;
      if (this.configurationHelper[key].type === "multiselect") {
        this.addEditValue = JSON.parse(value);
      } else {
        this.addEditValue = value;
      }
      this.addEditDialogIsEditMode = true;

      this.showAddEditDialog = true;
    },
    closeAddEditDialog() {
      this.showAddEditDialog = false;
      this.addEditValue = null;
      this.addEditKey = null;
      this.addEditDialogIsEditMode = false;
    },
    copyHash(hash) {
      navigator.clipboard.writeText(hash)
      NotificationStore.notify({
        message: "Successfully copied!",
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "success",
      });
    },
    async applyConfiguration() {
      this.showWaitingForServerDialog = true;

      await this.$api.applyServerConfiguration();
      await this.waitForServer();

      this.showWaitingForServerDialog = false;
      await this.getConfigurationData();
    }
  },
  mounted() {
    this.getConfigurationData();
  }
};
</script>
<style lang="scss">
.stat-card {
  @media (max-width: 1400px) {
    min-width: 50% !important;
    max-width: 50% !important;
    flex: 0 1 50% !important;
  }
  @media (max-width: 540px) {
    min-width: 100% !important;
    max-width: 100% !important;
    flex: 0 1 100% !important;
  }
}

.md-tooltip {
  max-width: 60%;
  text-wrap: normal;
}

.md-tooltip.helper-tooltip {
  max-width: 60vw;
  width: fit-content;
  text-wrap: normal;

  span {
    display: block;
    white-space: normal;
    text-align: justify;
  }
}

.action-buttons {
  display: flex;
  flex-direction: row-reverse;
}

.md-card-avatar .md-icon {
  font-size: 100px !important;
  padding: 15px;
  width: 100%;
  height: 100%;
  min-width: 100% !important;
  display: inline-block;
}

.license-table tbody > tr > :nth-child(1) {
  text-align: left;
}

.license-table tbody > tr > :last-child {
  display: flex;
  justify-content: center;
}

.configuration-table-actions {
  display: flex;
  justify-content: flex-end;

  .md-table-cell-container {
    margin-top: -5px;
  }
}

.ellipsis-hash{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100px;
}

.hash-container {
  display: flex;
  align-items: center;
}
</style>
